import { render, staticRenderFns } from "./InfoFooterTestB.vue?vue&type=template&id=a313842e&scoped=true"
import script from "./InfoFooterTestB.vue?vue&type=script&lang=js"
export * from "./InfoFooterTestB.vue?vue&type=script&lang=js"
import style0 from "./InfoFooterTestB.vue?vue&type=style&index=0&id=a313842e&prod&lang=scss&scoped=true"
import style1 from "./InfoFooterTestB.vue?vue&type=style&index=1&id=a313842e&prod&scss=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a313842e",
  null
  
)

export default component.exports